import { GlobalContext, GlobalStores } from "./GlobalContext";
import { QueryClient, QueryClientProvider } from "react-query";
import ErrorStore from "./core/api/ErrorStore";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, Theme, ThemeProvider } from "@mui/material/styles";
import { MuiTheme } from "./MuiTheme";
import { Router } from "react-router-dom";
import RedshiftPartner from "./auth/RedshiftPartner";
import LoginStateProvider from "./LoginStateProvider";
import ExternalServices from "./ExternalServices";
import { AppRoutesContainer } from "./AppRoutesContainer";
import { ToastContainer } from "react-toastify";
import { History } from "history";
import React from "react";
import { MainLoadingPlaceholder } from "./MainLoadingPlaceholder";

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export default function OldAppRoot({
  globalStores,
  queryClient,
  errorStore,
  browserHistory,
}: {
  globalStores: GlobalStores;
  queryClient: QueryClient;
  browserHistory: History;
  errorStore: ErrorStore;
}) {
  const auth = globalStores.authApi;
  return (
    <Router history={browserHistory}>
      <GlobalContext.Provider value={globalStores}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={MuiTheme}>
              <RedshiftPartner>
                <LoginStateProvider loginAuth={auth} loader={MainLoadingPlaceholder}>
                  <ExternalServices>
                    <AppRoutesContainer errorStore={errorStore} />
                  </ExternalServices>
                </LoginStateProvider>
              </RedshiftPartner>
            </ThemeProvider>
          </StyledEngineProvider>
          <ToastContainer
            pauseOnFocusLoss
            toastClassName="notification-container"
            bodyClassName="notification-body"
            progressClassName="notification-progress"
            position="top-left"
          />
        </QueryClientProvider>
      </GlobalContext.Provider>
    </Router>
  );
}
